import { useEffect } from "react";
import { PerformanceEvents, VideoEvents } from "../../../globals";
import { useVideoDataContext } from "../../contexts/VideoDataContext";
import { useVideoElementRefContext } from "../../contexts/VideoElementRefContext";
import { addOrcaEvent } from "../../utils";
import { sendVideoSplunkEvent } from "../../utils/splunk/sendVideoSplunkEvent";
import {
  SPLUNK_EVENT_NAMES,
  SPLUNK_EVENT_TYPES
} from "../../splunk-events/globals";
import { useVideoAnalyticsContext } from "../../contexts/VideoAnalyticsContext";

/**
 * Custom hook to handle initial ORCA render.
 * @param {Ref} ref
 * @param {Object} config
 * @param {boolean} isLive
 * @param {Function} onVideoRendered
 */
export const useOrcaRender = (ref, config, isLive, onVideoRendered) => {
  const { videoId } = useVideoDataContext();
  const videoElementRef = useVideoElementRefContext();
  const { sendPerformanceEvent = () => {} } = useVideoAnalyticsContext();
  const { debug = false } = config;
  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent(VideoEvents.ORCA_RENDER, {
        detail: { videoId, videoElementRef, orcaRef: ref }
      })
    );
    addOrcaEvent(VideoEvents.ORCA_RENDER, true, videoId, debug);
    sendVideoSplunkEvent(
      videoElementRef,
      SPLUNK_EVENT_TYPES.RENDER,
      SPLUNK_EVENT_NAMES.RENDER,
      { isLive },
      config
    );
    onVideoRendered({
      id: videoId,
      node: videoElementRef.current,
      orcaPlayer: ref
    });
    sendPerformanceEvent(PerformanceEvents.ORCA_RENDER);
  }, []);
};
